import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  outerContainer: {
    flexWrap: "wrap",
    flexDirection: "row",
    alignSelf: "center",
    marginHorizontal: 20,
    justifyContent: "space-evenly",
  },

  imgPegadaCarbono: {
    flexWrap: "wrap",
    width: 400,
    height: 325,
  },

  goBackBtn: {
    alignSelf: "flex-end",
    marginTop: 12,
    flexWrap: "wrap",
  },

  container: {
    marginTop: 20,
    marginBottom: 20,
    flex: 1,
    paddingTop: 20,
    backgroundColor: "#077A97",
    borderRadius: 8,
    paddingHorizontal: 20,
    paddingBottom: 20,
    flexWrap: "wrap",
    flex: 1,
  },

  searchInput: {
    height: 40,
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 10,
    marginBottom: 10,
    color: "#FFF",
  },
  categoryItem: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
  subcategoryContainer: {
    marginTop: 30,
    padding: 16,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 8,
  },
  subcategoryLabel: {
    color: "#ACEBEF",
    fontSize: 18,
    marginBottom: 6,
    marginTop: 12,
  },
  txtNecessarios: {
    textAlign: "center",
    color: "#FFF",
    marginBottom: 6,
    marginTop: 6,
  },

  btnCalcular: {
    borderWidth: 1,
    borderColor: "#FFF",
    marginVertical: 12,
    padding: 10,
    width: "100%",
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#FFF",
    position: "relative",
  },

  txtBtnCalcular: {
    color: "#077A97",
    textTransform: "uppercase",
    letterSpacing: 1,
  },

  hrLine: {
    height: 0.2,
    width: "100%",
    borderWidth: 0.2,
    marginTop: 10,
    marginBottom: 10,
    borderColor: "#ACEBEF",
  },

  selosNecessarios: {
    fontWeight: "bold",
    fontSize: 30,
    color: "#ACEBEF",
    textAlign: "center",
  },

  containerResultado: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },

  result: {
    fontWeight: "bold",
    color: "#ACEBEF",
    fontSize: 30,
    textAlign: "center",
  },
});

export default styles;
